import React, { useState, useEffect } from "react";
import { AddInstrumentFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import {
  CATE_PRODUCT_OPTION_OBJECT,
  INSTUMENT_TYPE_OPTIONS,
} from "utils/functions/productBooking";
import { Buttons, Inputs } from "components";

const AddInstrumentForm = ({
  initialValues,
  onSubmit,
  onBack,
  onDelete,
  onUpdate,
}) => {
  const schema = yup.object().shape({
    instrument_type: yup
      .object()
      .nullable()
      .required("Instrument type is required"),
    product: yup.object().nullable().required("Product is required"),
    brand: yup.string().required("Brand is required"),
    model: yup.string().required("Model is required"),
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { i18n } = useTranslation(["common", "register"]);

  const [productOptions, setProductOptions] = useState([]);

  useEffect(() => {
    if (initialValues) {
      reset({ ...initialValues });
    }
  }, [initialValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (initialValues) {
      reset({
        ...initialValues,
        instrument_type: initialValues.instrument_type_code
          ? {
              label:
                i18n.language === "en"
                  ? initialValues.instrument_type_en
                  : initialValues.instrument_type_th,
              value: initialValues.instrument_type_code,
            }
          : null,
        product: initialValues.product_code
          ? {
              label:
                i18n.language === "en"
                  ? initialValues.product_en
                  : initialValues.product_th,
              value: initialValues.product_code,
            }
          : null,
      });

      if (initialValues.instrument_type_code) {
        setProductOptions(
          CATE_PRODUCT_OPTION_OBJECT[initialValues.instrument_type_code]?.map(
            (g) => ({
              ...g,
              label: i18n.language === "en" ? g.labelEn : g.labelTh,
              value: g.value,
            })
          ) || []
        );
      }
    }
  }, [initialValues, i18n.language, reset]);

  return (
    <AddInstrumentFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="title_wrap">
          <div className="title">PROFILE &gt; {i18n.language === "en" ? "My Instrument" : "เครื่องดนตรีของฉัน"}</div>
          <div className="sub_title">
            {i18n.language === "en"
              ? "Let us get to know you better to offer exclusive activities,tailored to your preferences and to build your instrument history."
              : "ให้เรารู้จักคุณมากขึ้น เพื่อนำเสนอ กิจกรรมสุดพิเศษ\nสำหรับความชอบเฉพาะของคุณ และ สร้างประวัติเครื่องดนตรี"}
          </div>
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.DropdownSelect
                {...field}
                value={field.value}
                label={
                  i18n.language === "en"
                    ? "Choose type of musical instrument"
                    : "เลือกประเภทเครื่องดนตรี"
                }
                options={INSTUMENT_TYPE_OPTIONS.map((e) => ({
                  ...e,
                  label: i18n.language === "en" ? e.labelEn : e.labelTh,
                  value: e.value,
                }))}
                placeholder={
                  i18n.language === "en"
                    ? "Choose type of musical instrument"
                    : "เลือกประเภทเครื่องดนตรี"
                }
                errors={errors.instrument_type?.message}
                disabled={initialValues ? true : false}
                onChange={(e) => {
                  setValue("product", null);
                  field.onChange(e);
                  setProductOptions(
                    CATE_PRODUCT_OPTION_OBJECT[e.value]?.map((g) => ({
                      ...g,
                      label: i18n.language === "en" ? g.labelEn : g.labelTh,
                      value: g.value,
                    })) || []
                  );
                }}
              />
            )}
            name="instrument_type"
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.DropdownSelect
                {...field}
                label={
                  i18n.language === "en"
                    ? "Select product category"
                    : "เลือกกลุ่มสินค้า"
                }
                options={productOptions}
                placeholder={
                  i18n.language === "en"
                    ? "Select product category"
                    : "เลือกกลุ่มสินค้า"
                  // : i18n.language === "en"
                  // ? "Choose Product Model"
                  // : "เลือกกลุ่มสินค้า"
                }
                errors={errors.product?.message}
                disabled={initialValues ? true : false}
              />
            )}
            name="product"
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                label={i18n.language === "en" ? "Brand" : "ยี่ห้อ"}
                {...field}
                placeholder={i18n.language === "en" ? "Brand" : "ยี่ห้อ"}
                errors={errors.brand?.message}
              />
            )}
            name="brand"
            defaultValue=""
          />
        </div>

        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={i18n.language === "en" ? "Model" : "รุ่น"}
                placeholder={i18n.language === "en" ? "Model" : "รุ่น"}
                errors={errors.model?.message}
              />
            )}
            name="model"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={i18n.language === "en" ? "Series" : "ซีรี่ย์"}
                placeholder={i18n.language === "en" ? "Series" : "ซีรี่ย์"}
                errors={errors.series?.message}
              />
            )}
            name="series"
            defaultValue=""
          />
        </div>
        <div className="input_wrap mb_44">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={
                  i18n.language === "en" ? "Serial Number" : "หมายเลขซีเรียล"
                }
                placeholder={
                  i18n.language === "en" ? "Serial Number" : "หมายเลขซีเรียล"
                }
                errors={errors.serial_no?.message}
              />
            )}
            name="serial_no"
            defaultValue=""
          />
        </div>
        {!initialValues ? (
          <div className="btn_row_wrap">
            <div className="btn_wrap">
              <Buttons.BgStandard
                theme_white_purple
                type="button"
                label={i18n.language === "en" ? "Back" : "ย้อนกลับ"}
                onClick={onBack}
              />
            </div>
            <div className="btn_wrap">
              <Buttons.BgStandard
                type="submit"
                label={i18n.language === "en" ? "Add" : "เพิ่มข้อมูล"}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="btn_row_wrap">
              <div className="btn_wrap">
                <Buttons.BgStandard
                  theme_red
                  type="button"
                  label={i18n.language === "en" ? "Delete" : "ลบ"}
                  onClick={() => onDelete(initialValues._id)}
                />
              </div>
              <div className="btn_wrap">
                <Buttons.BgStandard
                  type="button"
                  label={i18n.language === "en" ? "Update" : "อัพเดท"}
                  onClick={handleSubmit(onUpdate)}
                />
              </div>
            </div>
            <div className="btn_wrap">
              <Buttons.BgStandard
                theme_white_purple
                type="button"
                label={i18n.language === "en" ? "Back" : "ย้อนกลับ"}
                onClick={onBack}
              />
            </div>
          </>
        )}
      </form>
    </AddInstrumentFormStyled>
  );
};

AddInstrumentForm.propTypes = {};

export default AddInstrumentForm;
